import styled, { css } from "styled-components";
import { Link } from "react-router-dom";

export const StyledRecentPlans = styled.div`
    display: grid;
    grid-template-columns: 139px 139px 139px 139px 139px;
    grid-column-gap: 28px;
    grid-row-gap: 18px;
    min-height: 108px;

    ${p =>
        p.theme.sm.only(css`
            grid-template-columns: 139px 139px 139px 139px;
            justify-content: center;
            grid-column-gap: 18px;
            min-height: 232px;
        `)}

    ${p =>
        p.theme.xs(css`
            grid-template-columns: 1fr 1fr;
            grid-column-gap: 18px;
            min-height: 200px;
            @media screen and (min-width: 400px) {
                grid-template-columns: 1fr 1fr 1fr;
            }
        `)}
    > div {
        min-width: 0;
    }
`;

export const PlanTitle = styled(Link)`
    text-shadow: 1px 1px rgba(0, 0, 0, 0.4);
    margin-bottom: 6px;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    text-align: center;
    display: block;
`;
